import { requestApi } from '../util/network'

//礼品卡列表

export const getGiftCardList = () =>
  requestApi(
    '/GiftCard/list',
    'POST',
    {},
    'member'
  )
export const getGoldCardList = () =>
  requestApi(
    '/GiftCard/gold_list',
    'POST',
    {},
    'member'
  )
// 购买礼品卡
export const buyGiftCard =
  (params) =>
  requestApi(
      '/GiftCard/buy',
      'POST',
      params,
      'member'
  )
  // 我的礼品卡列表
export const getMyCardList =
(params) =>
  requestApi(
    '/GiftCard/order_list',
    'POST',
    params,
    'member'
  )
export const getMyGoldCardList =
(params) =>
  requestApi(
    '/GiftCard/order_gold_list',
    'POST',
    params,
    'member'
  )
// 获取分享页面数据
export const getShareGoods =
() =>
  requestApi(
    '/GiftCard/share_goods',
    'POST',
    {
    },
    'member'
  )
// 上传图片
export const uploadImg =
(params) =>
  requestApi(
    '/GiftCard/upload_img',
    'POST',
    params,
    'member'
  )
 // 分享
export const submitShares =
(params) =>
  requestApi(
    '/GiftCard/share_submit',
    'POST',
    params,
    'member'
  ) 
  // 分享页面列表
export const getShareOrderList =
(params) =>
  requestApi(
    '/GiftCard/share_order_list',
    'POST',
    params,
    'member'
  )